import Vue from 'vue'
import element from './plugins/element-ui'
import router from './plugins/router'
import store from './plugins/vuex'
import axios from './plugins/axios'
import './plugins/registerServiceWorker'
import filters from './helpers/filters'
import mixin from './helpers/mixin'
import App from './App.vue'
// import './assets/scss/index.scss'

require('./bootstrap')

/* add font awesome icon component */

Vue.filter('date', filters.date)
Vue.filter('datetime', filters.datetime)
Vue.filter('datetimesec', filters.datetimesec)
Vue.filter('day_month', filters.day_month)
Vue.filter('underscore_to_space', filters.underscore_to_space)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  axios,
  element,
  filters,
  mixin,
  render: h => h(App)
}).$mount('#app')
